export default "__VITE_ASSET__BC9K4EA3__"